import { AxiosError, AxiosResponse } from 'axios'


const fallback = {
  message: 'Ocorreu um erro inesperado no sistema, por favor tente novamente mais tarde.',
  error: {
    data: [],
    status: 503
  }
}

const apiMsg = [{
  code: 400,
  message: 'O sistema não entendeu seu pedido, por favor verifique seus dados e tente novamente.'
},{
  code: 401,
  message: 'Não conseguimos identificar você, por favor tente sair e fazer um novo login.'
},{
  code: 403,
  message: 'O sistema rejeitou seu pedido, por favor entre em contato com o suporte.'
},{
  code: 404,
  message: 'Não conseguimos encontrar o que você solicitou, por favor entre em contato com o suporte.'
},{
  code: 500,
  message: 'Ocorreu um erro no sistema, por favor tente novamente mais tarde.'
},{
  code: 503,
  message: 'O sistema está ocupado no momento, por favor tente novamente mais tarde.'
},{
  code: 509,
  message: 'O sistema está sobrecarregado no momento, por favor tente novamente mais tarde.'
}]

const aspnetMsg = [{
  code: 'ApiVersionUnspecified',
  message: 'O sua versão do serviço parece estar desatualizada, por favor entre em contato com o suporte.'
},{
  code: 'UnsupportedApiVersion',
  message: 'O sua versão do serviço parece estar desatualizada, por favor entre em contato com o suporte.'
},{
  code: 'InvalidApiVersion',
  message: 'O sua versão do serviço parece estar desatualizada, por favor entre em contato com o suporte.'
},{
  code: 'AmbiguousApiVersion',
  message: 'O sua versão do serviço parece estar desatualizada, por favor entre em contato com o suporte.'
}]

const getGenericMsg = responseCode => {
  const getCodeDigit = status => Math.floor(status / 100)

  const status =
    apiMsg.find(item => item.code === responseCode) ||
    apiMsg.find(item => getCodeDigit(item.code) === getCodeDigit(responseCode))

  return status
    ? [ fallback.message ]
    : [ status.message ]
}

const getAspNetErrors = data => {
  const compareCode = item => item.code === data.Error.Code

  return typeof data.Error !== 'undefined' && typeof data.Error.Code !== 'undefined'
    ? [ aspnetMsg.find(compareCode).message ]
    : []
}

const getFormatedError = errorList => {
  return errorList.map(error => error.message || error)
}

const getApiErrors = (data: any) => {
  const apiErrors = data instanceof Array
    ? getFormatedError(data)
    : getAspNetErrors(data)

  return apiErrors
}

/** Returns a list of error messages */
const apiErrorList = (error: AxiosError): string[] => {
  const { data, status } = typeof error.response !== 'undefined'
    ? error.response
    : fallback.error

  const errorList = data && typeof status === 'number'
    ? getApiErrors(data)
    : getGenericMsg(status)

  return errorList.length > 0
    ? errorList
    : getGenericMsg(status)
}

export { apiErrorList }